/**
 * Validates the email input field within the given form element.
 * Adds an event listener to the email input to check for a valid email format and display error messages.
 *
 * @param {HTMLInputElement} input
 * @param {string} inputId
 * @param {string} label
 */
function validateEmail(input, inputId, label) {
  const errorSpan = document.getElementById(`${inputId}-error`);
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$/g;

  input.addEventListener('input', () => {
    if (input.value.length > 0) {
      if (input.value.match(emailRegex)) {
        errorSpan.innerText = null;
      } else {
        errorSpan.innerText = `${label} contains an invalid email address.`;
      }
    } else {
      errorSpan.innerText = `${label} is required.`;
    }
  });
}

/**
 * Validates the phone input field within the given form element.
 * Adds an event listener to the phone input to check for a valid phone format and display error messages.
 *
 * @param {HTMLInputElement} input
 * @param {string} inputId
 * @param {string} label
 */
function validatePhone(input, inputId, label) {
  const errorSpan = document.getElementById(`${inputId}-error`);
  const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/g;

  input.addEventListener('input', () => {
    if (input.value.length > 0) {
      if (input.value.match(phoneRegex)) {
        errorSpan.innerText = null;
      } else {
        errorSpan.innerText = `${label} contains an invalid phone number.`;
      }
    } else {
      errorSpan.innerText = `${label} is required.`;
    }
  });
}

/**
 * Validates the text inputs within the given form element.
 * Adds an event listener to the inputs to check if text inputs are filled and display error messages.
 *
 * @param {HTMLInputElement} input
 * @param {string} inputId
 * @param {string} label
 */
function validateTextFields(input, inputId, label) {
  const errorSpan = document.getElementById(`${inputId}-error`);

  input.addEventListener('input', () => {
    if (input.value.trim().length > 0) {
      errorSpan.innerText = null;
    } else {
      errorSpan.innerText = `${label} is required.`;
    }
  });
}

/**
 *
 * @param {FormData} formData
 * @param {HTMLCollectionOf<HTMLLabelElement>} labels
 */
function validateFormOnSubmit(formData, labels) {
  let fieldsValid = [];
  let index = 0;

  formData.forEach((value, key) => {
    const labelValue = labels.namedItem(key);
    const requiredValues = [
      'first_name',
      'last_name',
      'company',
      'email',
      'phone',
      'industry',
      'street',
      'zip',
      'city',
      'country',
      'description',
    ];
    const isRequired = requiredValues.includes(key.toLowerCase());

    /**
     * @type {HTMLElement}
     */
    let errorSpan;

    if (isRequired) {
      errorSpan = document.getElementById(labelValue.htmlFor + '-error');
    }

    if (isRequired && value === '') {
      errorSpan.innerText = `${labelValue.innerText} is required.`;
      fieldsValid.push(false);
      const invalidInput = document.getElementById(labelValue.htmlFor);
      if (index === 0) invalidInput.focus();
      index += 1;
      return;
    }

    if (
      (key === 'email' && errorSpan.innerText !== '') ||
      (key === 'phone' && errorSpan.innerText !== '')
    ) {
      const invalidInput = document.getElementById(labelValue.htmlFor);
      if (index === 0) invalidInput.focus();
      fieldsValid.push(false);
      return;
    }

    if (errorSpan) {
      errorSpan.innerText = null;
    }
    fieldsValid.push(true);
  });

  const areFieldsValid = fieldsValid.find((field) => field === false);

  if (areFieldsValid !== undefined) {
    return false;
  }
  return true;
}

export function initializeCrmForm() {
  const form = document.getElementById('crm-form');

  if (form) {
    const formInputs = form.querySelectorAll('input, select, textarea');
    const labels = form.getElementsByTagName('label');

    formInputs.forEach((input) => {
      if (input.type !== 'hidden' && input.type !== 'submit') {
        const inputLabel = labels.namedItem(input.name);

        if (input.id === 'phone') {
          validatePhone(input, input.id, inputLabel.innerText);
          return;
        }
        if (input.id === 'email') {
          validateEmail(input, input.id, inputLabel.innerText);
          return;
        }
        validateTextFields(input, input.id, inputLabel.innerText);
      }
    });

    form.addEventListener('submit', (ev) => {
      const formData = new FormData(form);
      const isAgreementChecked = formData.has('disclaimer-agreement');
      const agreementError = document.getElementById(
        'disclaimer-agreement-error'
      );

      const isFormValid = validateFormOnSubmit(formData, labels);

      if (!isAgreementChecked) {
        agreementError.innerText = 'Disclaimer Agreement is required.';
      } else {
        agreementError.innerText = null;
      }

      if (!isAgreementChecked || !isFormValid) {
        ev.preventDefault();
        return false;
      }
      return true;
    });
  }
}
